import { IUser, UserStatus } from '@/models/users.model';
import { Tooltip } from '@/ui';
import { formatDate } from '@/utils';
import { ColumnsType } from 'antd/es/table';
import { TFunction } from 'react-i18next';
import StatusTag from '../../components/StatusTag/StatusTag';
import UserStatusChange from '../UserStatusChange/UserStatusChange';

type TGetUsersTableColumns = {
  t: TFunction;
  updateUserStatus: (id: string, status: UserStatus) => void;
};

export const getUsersTableColumns = ({ t, updateUserStatus }: TGetUsersTableColumns): ColumnsType<IUser> => [
  {
    title: t('users_list_id'),
    dataIndex: 'PK',
    key: 'PK',
    width: 100,
    render: (_, record) => (
      <Tooltip title={record.tripletex_customer_number}>{record.tripletex_customer_number}</Tooltip>
    ),
  },
  {
    title: t('users_list_name'),
    dataIndex: 'full_name',
    key: 'full_name',
    render: (full_name) => <span>{full_name}</span>,
  },
  {
    title: t('users_list_phone_number'),
    dataIndex: 'phone_number',
    key: 'phone_number',
    width: 150,
    render: (phone) => <span>{phone}</span>,
  },
  {
    title: t('users_list_email'),
    dataIndex: 'email',
    key: 'email',
    width: 200,
    render: (email) => <span>{email}</span>,
  },

  {
    title: t('users_list_address'),
    dataIndex: 'address',
    key: 'address',
    render: (address) => <span>{address?.full_address}</span>,
  },
  {
    title: t('users_list_registration_date'),
    dataIndex: 'created',
    key: 'created',
    render: (created) => <span>{created ? formatDate(created) : '-'}</span>,
  },
  {
    title: t('users_list_login_date'),
    dataIndex: 'last_login_at',
    key: 'last_login_at',
    render: (last_login_at) => <span>{last_login_at ? formatDate(last_login_at) : '-'}</span>,
  },
  {
    title: t('users_list_status'),
    dataIndex: 'status',
    key: 'status',
    render: (status) => <StatusTag status={status} />,
  },
  {
    title: t('users_list_actions'),
    key: 'actions',
    render: (_, record) => {
      return <UserStatusChange user={record} updateUserStatus={updateUserStatus} />;
    },
  },
];
